// extracted by mini-css-extract-plugin
module.exports = {"container":"welcome-message_container__2fH2E","text":"welcome-message_text__2u-O-"};